import React from 'react'

import moment from 'moment'
import {inWords, removeZeros} from '../../../utils/misc'
import {getUserSettings} from '../../../storage'
import HistoryChoser from '../historyChoser'

export default class PreviewMobile extends React.Component {

  render() {

    let company = this.props.company
    let invoice = this.props.invoice
    let historyRecords = this.props.history
    let settings = this.props.settings || getUserSettings()
    let brandRow = <small><i>Generated with https://www.goodsbill.com</i></small>
    let invoice_date = moment(invoice.date).format('D-MM-YYYY')

    let billto_1, billto_2, billFrom
    let place_of_supply
    let shipping_address
    let optionalRow = false
    let table_cols = 8
    let invoice_label = "INVOICE"

    let options, historySelection
    if(settings) {
      options = settings.options
    }
    if(options && options.show_invoice_history) {
      historySelection = <HistoryChoser handleHistorySelect={this.props.handleHistorySelect} records ={historyRecords} />
    }

    let serial = invoice.series_name + invoice.series_counter
    let bankDetails, declartion, tnc

    if(settings.invoice_label) {
      invoice_label = <div className="">
         <span>{settings.invoice_label}</span>
      </div>

      if(settings.show_invoice_tnc) {

      tnc = <div><u>Terms and Conditions</u>
            <div><p>{settings.invoice_tnc}</p></div>
            </div>
      }

      if(settings.show_invoice_declaration) {

      declartion = <div><u>Declaration</u>
            <div><p>{settings.invoice_declaration}</p></div>
            </div>
      }

      if(settings.show_invoice_bankdetails) {

        bankDetails = <div><div className="row">
              <div className="col-xs-12 space-small-bottom"><strong >Bank Details</strong></div>
            <div className="col-xs-6">Bank Name</div>
            <div className="col-xs-6">{company.bank_name}</div>
            </div>
            <div className="row">
              <div className="col-xs-6">Account No</div>
              <div className="col-xs-6">{company.account_no}</div>
            </div>
            <div className="row">
              <div className="col-xs-6">IFSC</div>
              <div className="col-xs-6">{company.ifsc_code}</div>
            </div>
            <div className="row">
              <div className="col-xs-6">Branch </div>
              <div className="col-xs-6">{company.branch_name}</div>
            </div>

            </div>
      }
    }

    let label_row=<tr><td colSpan={table_cols} className="text-center ">{invoice_label}</td></tr>



    let company_gstin, company_phone, company_name, company_address, company_additional_params

    if(typeof company.gstin !== "undefined" && company.gstin.length > 0) {
      company_gstin = <span>{"GSTIN: " +company.gstin}</span>
    }
    if(company.additional_params && company.additional_params.length) {
      let additional_params_list = company.additional_params.map(function(param, i) {
        return <li key={i}><span className="gray">{param.key} {param.value}</span></li>
      })
      company_additional_params= <ul className="list-inline" style={{marginBottom:0}}>{additional_params_list}</ul>
    }

    if(typeof company.phone !== "undefined" && company.phone.length > 0) {
      company_phone = <span >{"Ph: " +company.phone}</span>
    }
    if(typeof company.company_name !== "undefined" && company.company_name.length > 0) {
      company_name = <div className="company-name text-uppercase" style={{fontSize:26, fontWeight:400}}>

                      {company.company_name}
                    </div>
    }
    company_address = <div className=""> {company.address} {company.city} {company.state} {company.pin}</div>

    let invoice_box = <div>
    <div className="space-small">
    Invoice No: <strong>{serial}</strong>
    </div>
    <div className="space-small">
    Date: {invoice_date}
    </div>
    </div>

    let company_row = <tr><td colSpan={table_cols-2}>
    {company_name}
    {company_address}
    {company_gstin} {company_phone}
     </td><td colSpan={2}>
      {invoice_box}
     </td></tr>

     if(typeof invoice.client !== "undefined" && invoice.client !== null) {
       place_of_supply = invoice.client.city
       let client_gstin
       let client_phone
       if(typeof invoice.client.gstin !== "undefined" && invoice.client.gstin !== null && invoice.client.gstin.length > 0) {
         client_gstin = invoice.client.gstin
       }
       if(typeof invoice.client.phone !== "undefined" && invoice.client.phone !== null && invoice.client.phone.length > 0) {
         client_phone = invoice.client.phone
       }

       billto_1 =  <div className="row"><div className="col-xs-12">
         <div className="">
         <table>
         <tbody>
          <tr><td >Name: </td><td>{invoice.client.name}</td></tr>
          <tr><td>Phone: </td><td>{invoice.client.phone}</td></tr>
          <tr><td>Address: </td><td>{invoice.client.address} {invoice.client.city} {" "+invoice.client.state} {" "+invoice.client.pin}</td></tr>
          <tr><td>GSTIN: </td><td>{client_gstin}</td></tr>
          <tr><td>Ph: </td><td>{client_phone}</td></tr>
         </tbody>
         </table>
           <div>
           </div>
         </div>
       </div></div>

     }

     let client_row = <tr><td colSpan={table_cols} style={{paddingBottom:5}}>
     {billto_1}
     </td></tr>

     let header_row = <tr className="active">
        <td className="text-center" style={{maxWidth:18}}>S.No</td>
        <td>Description of Goods</td>
        <td className="text-center">HSN</td>
        <td className="text-center" style={{maxWidth:18}}>Qty</td>
        <td className="text-right">Rate</td>
        <td className="text-right">Discount</td>
        <td className="text-right">Tax</td>
        <td className="text-right">Amount</td>
     </tr>



     let items, summaryRow
     if(invoice.saleitem_set.length > 0) {
       invoice.saleitem_set.sort((a,b)=>{
         return a.tableIndex - b.tableIndex
       })
         items = invoice.saleitem_set.map((saleitem, index)=>{

           let imei_1, imei_2, battery, charger
           if(saleitem.extra){
              let extra = saleitem.extra
             if(extra.imei_1) {
               imei_1 = <div>IMEI 1: {extra.imei_1}</div>
             }
             if(extra.imei_2) {
               imei_2 = <div>IMEI 2: {extra.imei_2}</div>
             }
             if(extra.battery) {
               battery = <div>Battery: {extra.battery}</div>
             }
             if(extra.charger) {
               charger = <div>Charger: {extra.charger}</div>
             }

           }
           let description = <div>
                <div>{saleitem.brand_name} {saleitem.name}</div>
                {imei_1}
                {imei_2}
                {battery}
                {charger}
           </div>

           let discountCol, taxCol, sgstcol, igstcol

           let unit_price = Number(saleitem.selling_rate),
           taxable_price = parseFloat(saleitem.price).toFixed(2),
           item_total = parseFloat(saleitem.total).toFixed(2)


           if(saleitem.cgst_amount > 0) {
             taxCol=  <td  className="text-right">
             {parseFloat(saleitem.igst_amount).toFixed(2)} ({Number(saleitem.gst.igst)}%)
                </td>
           }
           else {
             taxCol= <td className="text-right"></td>
           }

           if(saleitem.discount_value > 0) {
               discountCol = <td className="text-right">{removeZeros(saleitem.discount_value)}</td>
           }
           else {
             discountCol = <td className="text-right"></td>
           }

           return <tr key={index}>
             <td className="text-center">{saleitem.tableIndex}</td>
             <td><div>{description}</div> </td>
             <td className="text-center"><div>{saleitem.hsn}</div> </td>
             <td className="text-center">
               <div>{Number(saleitem.quantity)}</div>
             </td>

             <td className="text-right">{unit_price}</td>
             {discountCol}
             {taxCol}
             <td className="text-right">{taxable_price}</td>
         </tr>

         })
     }




          let summaryQuantity=0, summaryDiscount=0, summaryTaxable=0, summaryIGST=0, summaryCGST=0, summarySGST=0, summaryTotal=0, summaryRate=0
          let percentages={cgst:{}, sgst:{}, igst:{}}
          for (var i = 0; i < invoice.saleitem_set.length; i++) {
              const si = invoice.saleitem_set[i]
              summaryRate = summaryRate + (parseFloat(si.quantity)* parseFloat(si.selling_rate))
              summaryQuantity = summaryQuantity + parseFloat(si.quantity)
              summaryDiscount = summaryDiscount + parseFloat(si.discount_value)
              summaryTaxable = summaryTaxable + parseFloat(si.price)
              summaryIGST = summaryIGST + parseFloat(si.igst_amount)
              summaryCGST = summaryCGST + parseFloat(si.cgst_amount)
              summarySGST = summarySGST + parseFloat(si.sgst_amount)
              summaryTotal = summaryTotal + parseFloat(si.total)
              const unique_cgst_pct = si.gst.cgst, unique_sgst_pct = si.gst.sgst, unique_igst_pct = si.gst.igst
              const igst_s_amount = parseFloat(si.igst_amount)
              const cgst_s_amount = parseFloat(si.cgst_amount)
              const sgst_s_amount = parseFloat(si.sgst_amount)
              const taxable_price = parseFloat(si.price)
              const total = parseFloat(si.total)

              let cgst_percentages = percentages['cgst']

              if(typeof cgst_percentages[unique_cgst_pct] !== "undefined") {
                let s = cgst_percentages[unique_cgst_pct]

                s.cgst_amount= s.cgst_amount + cgst_s_amount
                s.sgst_amount= s.sgst_amount + sgst_s_amount
                // s.igst_amount= s.igst_amount + igst_s_amount
                s.taxable_price = s.taxable_price + taxable_price
                s.total = s.total + total

              }
              else {
                cgst_percentages[unique_cgst_pct] = {cgst_amount:cgst_s_amount,  sgst_amount:sgst_s_amount, taxable_price: taxable_price, total: total}
                //percentages[unique_pct] = {igst_amount:igst_s_amount, cgst_amount:cgst_s_amount, sgst_amount:sgst_s_amount, taxable_price: taxable_price, total: total}
              }
              percentages['cgst'] = cgst_percentages

              let igst_percentages = percentages['igst']

              if(typeof igst_percentages[unique_igst_pct] !== "undefined") {
                let s = igst_percentages[unique_igst_pct]
                s.igst_amount= s.igst_amount + igst_s_amount
                s.taxable_price = s.taxable_price + taxable_price
                s.total = s.total + total
              }
              else {
                igst_percentages[unique_igst_pct] = {igst_amount:igst_s_amount, taxable_price: taxable_price, total: total}
                //percentages[unique_pct] = {igst_amount:igst_s_amount, cgst_amount:cgst_s_amount, sgst_amount:sgst_s_amount, taxable_price: taxable_price, total: total}
              }

              percentages['igst'] = igst_percentages
            }

            summaryRate = parseFloat(summaryRate).toFixed(2)
            summaryDiscount = parseFloat(summaryDiscount).toFixed(2)
            summaryTaxable = parseFloat(summaryTaxable).toFixed(2)
            summaryIGST = parseFloat(summaryIGST).toFixed(2)
            summaryCGST = parseFloat(summaryCGST).toFixed(2)
            summarySGST = parseFloat(summarySGST).toFixed(2)
            summaryTotal = parseFloat(summaryTotal).toFixed(2)


          let cgst_percentages = percentages['cgst']
          let keys =  Object.keys(cgst_percentages)
          let summary_cgst_row = keys.map((pct_key)=>{
            let cgst_percentage = cgst_percentages[pct_key]
            return <tr className="text-right" key={"cgst_summary_row"+pct_key}>
                  <td colSpan={table_cols-2} style={{borderBottomWidth:1,borderBottomStyle:'solid', borderBottomColor:'transparent'}}></td>
                  <td>CGST ({pct_key}%)</td>
                  <td>{parseFloat(cgst_percentage.cgst_amount).toFixed(2)}</td>
            </tr>
          })

          let summary_sgst_row = keys.map((pct_key)=>{
            let cgst_percentage = cgst_percentages[pct_key]

            return <tr className="text-right" key={"sgst_summary_row"+pct_key}>
                  <td colSpan={table_cols-2} style={{borderBottomWidth:1,borderBottomStyle:'solid', borderBottomColor:'transparent'}}></td>
                  <td>SGST ({pct_key}%)</td>
                  <td>{parseFloat(cgst_percentage.sgst_amount).toFixed(2)}</td>
            </tr>
          })


            let footer = <tr>
            <td colSpan={table_cols}>
             <div className="row">
                  <div className="col-xs-6">
                    {tnc}
                    {declartion}
                  </div>
                  <div className="col-xs-6 text-right">
                      <div className="space-medium-bottom">For <span>{company.company_name}</span></div>
                      <div>Authorized Signature</div>
                  </div>
            </div>
            </td>
            </tr>


    return   <div style={{position:'relative'}}>
      <div className="hidden-print" style={{position:'absolute', left:0}}>
        {historySelection}
      </div>

      <div className="preview-a4 mobile">
        <div className="text-right invoice-name">{this.props.print_type}</div>
      <table className="table table-bordered">
      <tbody>
        {label_row}
        {company_row}
        {client_row}
        {header_row}
        {items}


        {summary_cgst_row}
        {summary_sgst_row}
        <tr>
        <td colSpan={table_cols-2}></td><td className="text-right">TOTAL</td><td className="text-right">{summaryTotal}</td>
        </tr>
        <tr>
          <td colSpan={table_cols}>
            <ul className="list-inline">
              <li>Rupess In Words:</li>
              <li>{inWords(invoice.total)}</li>
            </ul>

          </td>
        </tr>
        {footer}
      </tbody>
      </table>
      {brandRow}
      </div>


    </div>


  }
}



// WEBPACK FOOTER //
// ./src/components/invoice/previews/previewmobile.js